import React, { useEffect, useRef, useState } from 'react';
import MapContainer from './googlemap/Map';
import {
    TextField,
    Button,
    MenuItem,
    FormControl,
    InputLabel,
    Select,
    Typography,
    Drawer,
    isWidthUp,
    makeStyles,
    Paper,
    IconButton,
    Box,
} from "@material-ui/core";
import { Polygon, Circle, Polyline, Marker, InfoWindow } from "@react-google-maps/api";
import { useHistory , useParams } from 'react-router-dom/cjs/react-router-dom.min';
import MainToolbar from './MainToolbar';
import { usePreference } from './common/preferences';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flexGrow: 1,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse',
        }
    },
    drawerPaper: {
        position: 'relative',
        [theme.breakpoints.up('sm')]: {
            width: 350,
        },
        [theme.breakpoints.down('xs')]: {
            height: 250,
        }
    },
    mapContainer: {
        flexGrow: 1,
    },
}));

const GeofenceAddEditMap = ({ width }) => {
    const classes = useStyles();
    const mapRef = useRef(null);
    const { id } = useParams();
    const userID = usePreference("id");
    const history = useHistory();
    const [mapCenter, setMapCenter] = useState({lat: 24,lng: 82,});
    const [zoom, setZoom] = useState(5);

    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [color, setColor] = useState("#0000FF");
    const [selectedLayer, setSelectedLayer] = useState("POLYGON");

    const [polygonPath, setPolygonPath] = useState([]);
    const [polylinePath, setPolylinePath] = useState([]);
    const [radius, setCircleRadius] = useState(0);
    const [center, setCircleCenter] = useState({});

    const polygonRef = useRef(null);
    const circleRef = useRef(null);
    const polylineRef = useRef(null);

    const [devices, setDevices] = useState([]);
    const [selectedDevice, setSelectedDevice] = useState(null);

    useEffect(() => {
        const fetchGeofence = async () => {
            if (id) {
                try {
                const response = await fetch("/api/geofences/" + id, {
                    method: "GET",
                    headers: {
                    "Content-Type": "application/json",
                    },
                });
        
                if (response.ok) {
                    const result = await response.json();
        
                    var area = result.area;
        
                    setName(result.name);
                    setDescription(result.description);
                    setColor(result.attributes.color);
        
                    const shapeType = area.split(" ")[0];
                    setSelectedLayer(shapeType);
        
                    if (shapeType === "CIRCLE") {
                        const index = area.indexOf(" ");
                        const details = area.substring(index + 1);
            
                        const cleaned = details.replace(/[()]/g, "");
                        const [coordsPart, radiusPart] = cleaned.split(",").map(s => s.trim());
            
                        const [lat, lng] = coordsPart.split(" ").map(Number);
                        const radius = Number(radiusPart);

                        setCircleRadius(radius);
                        setCircleCenter({ lat, lng });
                        setMapCenter({ lat, lng }); // make sure map centers here too
                        setZoom(16);
                    }

                    if(shapeType === "LINESTRING"){
                        const path = parseCoordToArray(area, shapeType);
                        setPolylinePath(path);
                        boundLatLng(path);
                    }

                    if(shapeType === "POLYGON"){
                        const path = parseCoordToArray(area, shapeType);
                        setPolygonPath(path);

                        boundLatLng(path);
                    }
                } else {
                    alert("Failed To Get Geofence!");
                }
                } catch (error) {
                alert("Something went wrong!!");
                }
            }
        };
        fetchGeofence();

        const fetchDevice = async () => {
            try {
                const response = await fetch(`/api/users/${userID}/allDevicesOnMap`);
                const data = await response.json();
            
                setDevices(data.devicesMapBasicDataList);
            
                // Prepare latlng array directly from the fetched data
                const latlngs = data.devicesMapBasicDataList
                .filter((device) => device.position)
                .map((device) => ({
                    lat: device.position.latitude,
                    lng: device.position.longitude,
                }));
            
                // Call your boundLatLng function with the new array
                if(!id){
                    boundLatLng(latlngs);
                }
            } catch (error) {
                console.error("Error fetching locations:", error);
            }
        };
        
        fetchDevice();
          

    }, [id]);
    

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name || !selectedLayer) {
            alert("Please fill in all fields");
            return;
        }

        var area = selectedLayer+" ";
        if(selectedLayer === "CIRCLE"){
            area += "("+center["lat"]+" "+center["lng"]+", "+ radius +")";
        }
        if(selectedLayer === "POLYGON"){
            area += convertToWKTFormat(polygonPath);
        }
        if(selectedLayer === "LINESTRING"){
            area += convertToWKTFormat(polylinePath);
        }

        const formData = {
            "id": id?id:"",
            "name": name,
            "description": description,
            "area": area,
            "calendarId": 0,
            "attributes": {
                "color": color
            }
        };
        
        try {
            var response;
            if(id){
                response = await fetch("/api/geofences/"+id, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
                });
            }else{
                response = await fetch("/api/geofences/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
                });
            }
        
            if (response.ok) {
                const result = await response.json();
            }
        } catch (error) {
            alert("Something went wrong!!");
        }
        history.push(`/reports/geofence`);
    };

    const convertToWKTFormat = (points) => {
        const coords = points.map(point => `${point.lat} ${point.lng}`).join(", ");
        if(selectedLayer === "LINESTRING") return `(${coords})`; 
        if(selectedLayer === "POLYGON")return `((${coords}))`;
    };

    const parseCoordToArray = (wktString, shapeType)=>{
        var coordsString;
        if(shapeType === "LINESTRING"){
            coordsString = wktString.replace("LINESTRING (", "").replace(")", "");
        }
        if(shapeType === "POLYGON"){
            coordsString = wktString.replace("POLYGON ((", "").replace("))", "");
        }
      
        const coordsArray = coordsString.split(",").map(coord => {
            const [lat, lng] = coord.trim().split(" ").map(Number);
            return { lat, lng };
        });
      
        return coordsArray;
    }

    const handleChange = (e) => {
        setSelectedLayer(e.target.value);

        const layers = {
            circle: 'circle-source',
            polygon: 'polygon-source',
            polyline: 'polyline-source',
        };
    };

    const handleMapLoad = (map) => {
        mapRef.current = map;
    };

    const onPolygonEdit = () => {
        if (polygonRef.current) {
            const newPath = polygonRef.current.getPath().getArray().map(latlng => ({
            lat: latlng.lat(),
            lng: latlng.lng()
            }));
            setPolygonPath(newPath);
        }
    };

    const onPolylineEdit = () => {
        if (polylineRef.current) {
            const newPath = polylineRef.current.getPath().getArray().map(latlng => ({
                lat: latlng.lat(),
                lng: latlng.lng()
            }));
            setPolylinePath(newPath);
        }
    };

    const handleMapClick = (e) => {
        const latLng = {
            lat: e.latLng.lat(),
            lng: e.latLng.lng()
        };
    
        if (selectedLayer === "POLYGON") {
            setPolygonPath(prev => [...prev, latLng]);
        } else if (selectedLayer === "LINESTRING") {
            setPolylinePath(prev => [...prev, latLng]);
        } else if (selectedLayer === "CIRCLE") {
            setCircleCenter(latLng);
        }
    };

    const boundLatLng = (path) =>{
        const bounds = new window.google.maps.LatLngBounds();
        path.forEach(point => {
            bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
        });

        // Now you can use it to adjust the map view
        if (mapRef.current) {
            mapRef.current.fitBounds(bounds);
        }
    }

    const onBack = () => {
        history.push("/reports/geofence")
    }

    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <MainToolbar/>
                <Drawer
                    anchor={isWidthUp('sm', width) ? 'left' : 'bottom'}
                    variant='permanent'
                    classes={{ paper: classes.drawerPaper }}
                >
                    <Paper
                        component="form"
                        style={{ height: "100vh", padding: 20 }}
                        noValidate
                        autoComplete="off"
                        >
                        <Box display="flex" alignItems="center">
                            <IconButton
                                onClick={onBack}
                                style={{
                                backgroundColor: "#FFFFFF",
                                color: "#000000",
                                marginTop: -10
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                            <Typography variant="h5" gutterBottom>
                                Add New Geofence
                            </Typography>
                        </Box>
                        <form onSubmit={handleSubmit}>
                            <TextField
                                label="Geofence Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                fullWidth
                                margin="normal"
                                required
                            />

                            <TextField
                                label="Description"
                                type='description'
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                fullWidth
                                margin="normal"
                            />

                            <FormControl fullWidth margin="normal">
                                <InputLabel>GeoFence Type</InputLabel>
                                <Select value={selectedLayer} onChange={handleChange}>
                                    <MenuItem value="CIRCLE">Circle</MenuItem>
                                    <MenuItem value="POLYGON">Polygon</MenuItem>
                                    <MenuItem value="LINESTRING">Polyline</MenuItem>
                                </Select>
                            </FormControl>

                            <TextField
                                label="Color"
                                type='color'
                                value={color}
                                onChange={(e) => setColor(e.target.value)}
                                fullWidth
                                margin="normal"
                            />

                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                style={{ marginTop: 16 }}
                                fullWidth
                                onClick={handleSubmit}
                            >
                                Submit
                            </Button>
                        </form>
                    </Paper>
                </Drawer>
                <div className={classes.mapContainer}>
                    <MapContainer center={mapCenter} loadHandler={handleMapLoad} zoom={zoom} onClick={handleMapClick}>
                    {selectedLayer === "POLYGON" && (
                    <Polygon
                        paths={polygonPath}
                        editable={true}
                        draggable={true}
                        onMouseUp={onPolygonEdit}
                        onLoad={polygon => polygonRef.current = polygon}
                        options={{
                            strokeColor: color,
                            fillColor: color,
                            strokeWeight: 2
                        }}
                    />
                    )}

                    {selectedLayer === "CIRCLE" && (
                    <Circle
                        center={center}
                        radius={radius}
                        editable={true}
                        draggable={true}
                        onLoad={circle => (circleRef.current = circle)}
                        onRadiusChanged={() => {
                        if (circleRef.current) {
                            const newRadius = circleRef.current.getRadius();
                            setCircleRadius(newRadius);
                        }
                        }}
                        onDragEnd={() => {
                        if (circleRef.current) {
                            const newCenter = circleRef.current.getCenter();
                            if (newCenter) {
                            const lat = newCenter.lat();
                            const lng = newCenter.lng();
                            setCircleCenter({ lat, lng });
                            }
                        }
                        }}
                        options={{
                        strokeColor: color,
                        fillColor: color,
                        strokeWeight: 2
                        }}
                    />
                    
                    )}

                    {selectedLayer === "LINESTRING" && polylinePath.length >= 2 && (
                    <Polyline
                        path={polylinePath}
                        editable={true}
                        draggable={true}
                        onMouseUp={onPolylineEdit}
                        onLoad={polyline => polylineRef.current = polyline}
                        options={{
                        strokeColor: color,
                        strokeWeight: 2
                        }}
                    />
                    )}

                    {devices.map((device, index) => (
                    device.position ? (
                        <Marker
                        key={index}
                        position={{
                            lat: device.position.latitude,
                            lng: device.position.longitude,
                        }}
                        onClick={() => setSelectedDevice(device)}
                        />
                    ) : null
                    ))}

                    {selectedDevice && (
                    <InfoWindow
                        position={{
                        lat: selectedDevice.position.latitude,
                        lng: selectedDevice.position.longitude,
                        }}
                        onCloseClick={() => setSelectedDevice(null)}
                    >
                        <div>{selectedDevice.device.name}</div>
                    </InfoWindow>
                    )}
                    </MapContainer>
                </div>
            </div>
        </div>
    );
}

export default GeofenceAddEditMap;
